export const rutaPaciente = "/admin/patient/profile/";

export const pasos = {
    SELECCIONAR_GESTOR: 'Seleccionar gestor',
    SELECCIONAR_CITA: 'Seleccionar consulta',
    SELECCIONAR_FECHA_CITA: 'Seleccionar fecha',
    INGRESAR_UBICACION: 'Ingresar ubicación'
};

export const mensajesError = {
  SELECCIONAR_GESTOR: "Por favor, seleccione un gestor.",
  SELECCIONAR_PACIENTE: "Por favor, seleccione un paciente.",
  SELECCIONAR_CITA: "Por favor, seleccione una cita.",
  SELECCIONAR_FECHA: "Por favor, seleccione una fecha.",
  SELECCIONAR_HORA: "Por favor, seleccione una hora.",
  COMPLETAR_CAMPOS: "Por favor, complete todos los campos."
};


/*
EST-036	Activa
EST-037	Cerrada
EST-038	Anulada
*/
export const solicitudSusbcripcionCode = {
  Activa: { text: "Activa", value: "EST-036", color: "gray" },
  Cerrada: { text: "Cerrada", value: "EST-037", color: "" },
  Anulada: { text: "Anulada", value: "EST-038 ", color: "" },
};


/*
EST-039	Subscrito
EST-040	No Subscrito
EST-041	Suspendida
*/
export const subscripcionAgendaEstatusCode = {
  Subscrito: { text: "Subscrito", value: "EST-039", color: "gray" },
  NoSubscripto: { text: "No Subscrito", value: "EST-040", color: "" },
  Suspendida: { text: "Suspendida", value: "EST-041", color: "" },
};

export const coloresGestores = [
  "#B19CD9",
  "#FFB6C1",
  "#98FB98",
  "#ADD8E6",
  "#FFD700",
  "#FFA07A",
  "#7FFFD4",
  "#F08080",
  "#BA55D3",
  "#FF69B4",
];